// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__cqJ1j","image":"Header_image__3pd2-","name":"Header_name__1UUaJ","info":"Header_info__1tUQI","infoRow":"Header_infoRow__3KRYV"};